import { postProductToUserList, getUserLists } from "@utils/call-api/userlists-call";

export const TYPES = {
  SET_USERLISTS: "SET_USERLISTS",
  OPEN_ADDED_TO_WISHLIST_TOAST: "OPEN_ADDED_TO_WISHLIST_TOAST",
  CLOSE_ADDED_TO_WISHLIST_TOAST: "CLOSE_ADDED_TO_WISHLIST_TOAST",
  OPEN_ADD_TO_USERLIST_OFFCANVAS: "OPEN_ADD_TO_USERLIST_OFFCANVAS",
  CLOSE_ADD_TO_USERLIST_OFFCANVAS: "CLOSE_ADD_TO_USERLIST_OFFCANVAS",
  OPEN_ADDED_TO_USERLIST_TOAST: "OPEN_ADDED_TO_USERLIST_TOAST",
  CLOSE_ADDED_TO_USERLIST_TOAST: "CLOSE_ADDED_TO_USERLIST_TOAST",
  CLOSE_USERLIST_MANAGER_ELEMENTS: "CLOSE_USERLIST_MANAGER_ELEMENTS",
  OPEN_AUTH_OFFCANVAS_PRIOR_TO_LIKE_PRODUCT: "OPEN_AUTH_OFFCANVAS_PRIOR_TO_LIKE_PRODUCT",
  CLOSE_AUTH_OFFCANVAS_PRIOR_TO_LIKE_PRODUCT: "CLOSE_AUTH_OFFCANVAS_PRIOR_TO_LIKE_PRODUCT",
};

function setUserLists(userLists) {
  return {
    type: TYPES.SET_USERLISTS,
    userLists,
  };
}

export function reloadUserLists() {
  return async (dispatch) => {
    const userLists = await getUserLists();
    dispatch(setUserLists(userLists));
  };
}

export function openAddedToWishlistToast(product) {
  return (dispatch) => {
    dispatch({
      type: TYPES.OPEN_ADDED_TO_WISHLIST_TOAST,
      product,
    });
  };
}

export function closeAddedToWishlistToast() {
  return (dispatch) => {
    dispatch({
      type: TYPES.CLOSE_ADDED_TO_WISHLIST_TOAST,
    });
  };
}

export function openAddToUserListOffcanvas(product) {
  return (dispatch) => {
    dispatch(reloadUserLists());

    dispatch({
      type: TYPES.OPEN_ADD_TO_USERLIST_OFFCANVAS,
      product,
    });
  };
}

export function closeAddToUserListOffcanvas() {
  return (dispatch) => {
    dispatch({
      type: TYPES.CLOSE_ADD_TO_USERLIST_OFFCANVAS,
    });
  };
}

function openAddedToUserListToast(userList) {
  return (dispatch) => {
    dispatch({
      type: TYPES.OPEN_ADDED_TO_USERLIST_TOAST,
      userList,
    });
  };
}

export function addProductToUserList(userListUuid) {
  return async (dispatch, getState) => {
    const product = getState().userlists.product;
    const userList = await postProductToUserList(userListUuid, { product_id: product.id });
    dispatch(closeAddToUserListOffcanvas());

    setTimeout(() => {
      dispatch(openAddedToUserListToast(userList));
      dispatch(reloadUserLists());
    }, 100);
  };
}

export function closeAddedToUserListToast() {
  return (dispatch) => {
    dispatch({
      type: TYPES.CLOSE_ADDED_TO_USERLIST_TOAST,
    });
  };
}

export function closeUserListManagerElements() {
  return (dispatch) => {
    dispatch({
      type: TYPES.CLOSE_USERLIST_MANAGER_ELEMENTS,
    });
  };
}

export function openAuthOffcanvasPriorToLikeProduct(product) {
  return (dispatch) => {
    dispatch({
      type: TYPES.OPEN_AUTH_OFFCANVAS_PRIOR_TO_LIKE_PRODUCT,
      product,
    });
  };
}

export function closeAuthOffcanvasPriorToLikeProduct() {
  return (dispatch) => {
    dispatch({
      type: TYPES.CLOSE_AUTH_OFFCANVAS_PRIOR_TO_LIKE_PRODUCT,
    });
  };
}
